import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue';
import { ensureScriptLoaded } from '@/guiide/ts/utilities';


export default /*@__PURE__*/_defineComponent({
  __name: 'TrustPilot',
  setup(__props) {

const trustbox = ref(null);

onMounted(() => {
  ensureScriptLoaded('https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', () => {
    ;(window as any).Trustpilot?.loadFromElement(trustbox.value);
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "trustbox",
    ref: trustbox,
    class: "trustpilot-widget mb-5",
    "data-locale": "en-US",
    "data-template-id": "56278e9abfbbba0bdcd568bc",
    "data-businessunit-id": "5d68312aef620200012de4d6",
    "data-style-height": "58px",
    "data-style-width": "100%",
    "data-theme": "light"
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("a", {
      href: "https://uk.trustpilot.com/review/guiide.co.uk",
      target: "_blank",
      rel: "noopener"
    }, "Trustpilot", -1)
  ]), 512))
}
}

})